import { z } from "zod";

export const editFollowUpSchema = z.object({
  total: z.coerce.number().positive().min(1).max(90),
  unit: z.string().nonempty("Required"),
  text: z.string().nonempty("Required"),
});

export const DURATION_UNITS = [
  { value: "h", label: "Hours" },
  { value: "d", label: "Days" },
  { value: "wk", label: "Weeks" },
];
